/**
 * Created by evgenijsenkevic on 15/5/25
 */

const UnitsShopTutorial = function () {
    return new TutorialScenario("unitsshoptutorial", {
        listSteps: UnitsShopTutorial.listSteps,
        isAvailable: function () {
            return !cleverapps.forces.isShown(Forces.UNITS_SHOP_ICON)
                && cleverapps.unitsShop && Map2d.currentMap
                && cleverapps.unitsShop.getAvailableShops().length > 0
                && Map2d.currentMap.listAvailableUnits({ code: "discountshop", stage: 0 }).length;
        }
    });
};

UnitsShopTutorial.listSteps = function () {
    return [
        new TutorialStep({
            onStart: function () {
                this.unit = Map2d.currentMap.listAvailableUnits({ code: "discountshop", stage: 0 })[0];

                const map = Map2d.currentMap;
                const mapView = map.getMapView();
                const unitPosition = mapView.alignInGrid(this.unit.x, this.unit.y);

                Map2d.currentMap.focusOnTarget(unitPosition, {
                    allowScrollWithFocus: true,
                    callback: function () {
                        this.highlighter = new UnitHighlighter(Map2d.currentMap.getMapView(), this.unit, { spotlight: true });

                        const dialogue = new Dialogue(UnitsShopTutorial.DIALOGUE, {
                            autoClose: true,
                            autoScroll: false,
                            showUp: true
                        });

                        dialogue.on("afterClose", () => {
                            if (this.highlighter) {
                                this.highlighter.unhighlight();
                            }
                            this.finish();
                        });

                        new DialogueView(dialogue);
                    }.bind(this)
                });
            },

            onFinish: function () {
                Map2dLocation.currentLocation.counter.trigger();
            }
        }),
        new TutorialStep({
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused("toolbar");

                const unitsShopItem = cleverapps.toolbar.getItem(ToolbarItem.UNIT_SHOP.type);

                this.force = cleverapps.forces.create(unitsShopItem.onGetView(), Forces.UNITS_SHOP_ICON, {
                    importantNodes: [ComponentUtils.findChildByName(cleverapps.Scenes.GetRunningScene(), "toolbar")]
                });
                cleverapps.tutorial.on("click_on_units_shop", this.finish.bind(this), this);
            },

            onFinish: function () {
                Map2dLocation.currentLocation.counter.trigger();
            }
        })
    ];
};

UnitsShopTutorial.DIALOGUE = [
    {
        text: "UnitsShopTutorial.step0",
        person: "dwarf",
        person2: {
            role: "king",
            orientation: "right"
        }
    },
    {
        text: "UnitsShopTutorial.step1",
        person: {
            role: "king",
            orientation: "right"
        },
        person2: "dwarf"
    }
];